const ServiceData = [
  {
    id: 1,
    imgURL: "/images/service1.jpg",
    title: "PREMIER HEALTHCARE SERVICES",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 2,
    imgURL: "/images/service2.jpg",
    title: "AMBULANCE SERVICE",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 3,
    imgURL: "/images/service3.jpg",
    title: "REHABILITATION UNIT",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 4,
    imgURL: "/images/service4.jpg",
    title: "OPERATION THEATRES",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 5,
    imgURL: "/images/service5.jpg",
    title: "IMAGING UNIT",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 6,
    imgURL: "/images/service6.jpg",
    title: "RECOVERY ROOM",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 7,
    imgURL: "/images/service7.jpg",
    title: "PHARMACY COUNTER",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 8,
    imgURL: "/images/service8.jpg",
    title: "PATIENT ROOMS",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 9,
    imgURL: "/images/service9.jpg",
    title: "CUSTOMER CARE SERVICES",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 10,
    imgURL: "/images/service10.jpg",
    title: "LABORATORY",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 11,
    imgURL: "/images/service11.jpg",
    title: "ENDOSCOPY UNIT",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
  {
    id: 12,
    imgURL: "/images/service12.jpg",
    title: "DOG BITE CORNER",
    route: "services",
    subTitle: [
      "Specialist consultation by victoria medical officer (MO)",
      "Treatment given by victoria medical officer (MO)",
      "Injection administered by victoria medical officer (MO) - special drug (Clexane, Epogen,Recormon,Neupogen)",
      "Home service for ECG , 24hr holter monitor, 24hr Ambulatory BP monitor",
      "Dressing for any wound, urinary catheter insertion, nasogastric tube insertion",
    ],
    description:
      "It is a team comprises of carefully selected medical personnel, and specially created to extend victoria's renowned quality care (medical & healthcare) to those who seek uncompromising medical attention.",
  },
];

export default ServiceData;
